export const LOCALSTORAGE_EMAIL = "email";
export const LOCALSTORAGE_USER_TOKEN_KEY = "userToken";
export const LOCALSTORAGE_FACILITY_ID = "facilityId";
export const LOCALSTORAGE_USER_ID = "impersonateUser";
export const LOCALSTORAGE_IDP_USER_FLAG = "isIDPUser";
export const LOCALSTORAGE_IMPERSONATION_TOKEN = "impersonationToken";
export const LOCALSTORAGE_IMPERSONATION_USER_DATA = "impersonationUserData";
